import { useGeoLookupContext } from '@/hooks/useGeoLookupContext';
import { config as variantConfig } from '@/pageConfig/life/us/bottom-sticky-cta';
import { LifePageTemplate } from '@/pageTemplate/LifePageTemplate';
import { useEffect } from 'react';

export default function PetPage() {
  const { trackEventWithGeolocation } = useGeoLookupContext();

  useEffect(
    () =>
      trackEventWithGeolocation('life_page.viewed', {
        experiment: 'bottom_sticky_cta_on',
      }),
    [],
  );

  return <LifePageTemplate config={variantConfig} />;
}
